"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../../stitches.config");

var _Input = _interopRequireDefault(require("../Input"));

var _NewsletterCheckbox = _interopRequireDefault(require("../newsletter-checkbox/NewsletterCheckbox"));

var DisplayEmail = (0, _stitches.styled)('div', {
  fontSize: '$normal',
  fontWeight: '$medium',
  marginBottom: '20px',
  padding: '8px',
  textAlign: 'center'
});
/**
 * User info displayed as input fields meant to be used in a form.
 * Validations must be done on the terminal app side.
 * Has configurations for:
 *   - birthday required
 *   - birthday visible
 *   - country required
 *   - country visible
 *   - first name required
 *   - first name visible
 *   - full name required
 *   - full name visible
 *   - gender required
 *   - gender visible
 *   - last name required
 *   - last name visible
 */

var UserInfoInputs = function UserInfoInputs(_ref) {
  var _errors$email, _formCopy$email, _errors$password, _formCopy$password, _errors$firstName, _formCopy$firstName, _errors$lastName, _formCopy$lastName, _errors$fullName, _formCopy$fullName, _errors$dob, _formCopy$dob, _errors$country, _formCopy$country, _errors$gender, _formCopy$gender;

  var birthdayInitialValue = _ref.birthdayInitialValue,
      birthdayRequired = _ref.birthdayRequired,
      birthdayVisible = _ref.birthdayVisible,
      countryRequired = _ref.countryRequired,
      countryVisible = _ref.countryVisible,
      emailRequired = _ref.emailRequired,
      emailVisible = _ref.emailVisible,
      errors = _ref.errors,
      firstNameRequired = _ref.firstNameRequired,
      firstNameVisible = _ref.firstNameVisible,
      formCopy = _ref.formCopy,
      fullNameRequired = _ref.fullNameRequired,
      fullNameVisible = _ref.fullNameVisible,
      genderRequired = _ref.genderRequired,
      genderVisible = _ref.genderVisible,
      lastNameRequired = _ref.lastNameRequired,
      lastNameVisible = _ref.lastNameVisible,
      newsletterOptVisible = _ref.newsletterOptVisible,
      passwordRequired = _ref.passwordRequired,
      passwordVisible = _ref.passwordVisible,
      prepopulatedEmail = _ref.prepopulatedEmail,
      register = _ref.register,
      showPlaceholders = _ref.showPlaceholders;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, prepopulatedEmail ? /*#__PURE__*/_react.default.createElement(DisplayEmail, null, prepopulatedEmail) : /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-email-required",
    "aria-invalid": (errors === null || errors === void 0 ? void 0 : errors.email) ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/email",
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$email = formCopy.email) === null || _formCopy$email === void 0 ? void 0 : _formCopy$email.label,
    name: "email",
    placeholder: showPlaceholders ? formCopy.email.placeholder : undefined,
    ref: register,
    required: emailRequired,
    type: "email",
    visible: emailVisible
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-password-required",
    "aria-invalid": (errors === null || errors === void 0 ? void 0 : errors.password) ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$password = errors.password) === null || _errors$password === void 0 ? void 0 : _errors$password.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/password",
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$password = formCopy.password) === null || _formCopy$password === void 0 ? void 0 : _formCopy$password.label,
    name: "password",
    placeholder: showPlaceholders ? formCopy.password.placeholder : undefined,
    ref: register,
    required: passwordRequired,
    type: "password",
    visible: passwordVisible
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-firstName-required",
    "aria-invalid": errors.firstName ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$firstName = errors.firstName) === null || _errors$firstName === void 0 ? void 0 : _errors$firstName.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/first-name",
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$firstName = formCopy.firstName) === null || _formCopy$firstName === void 0 ? void 0 : _formCopy$firstName.label,
    name: "firstName",
    placeholder: showPlaceholders ? formCopy.firstName.placeholder : undefined,
    ref: register,
    required: firstNameRequired,
    type: "text",
    visible: firstNameVisible
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-lastName-required",
    "aria-invalid": (errors === null || errors === void 0 ? void 0 : errors.lastName) ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$lastName = errors.lastName) === null || _errors$lastName === void 0 ? void 0 : _errors$lastName.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/last-name",
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$lastName = formCopy.lastName) === null || _formCopy$lastName === void 0 ? void 0 : _formCopy$lastName.label,
    name: "lastName",
    placeholder: showPlaceholders ? formCopy.lastName.placeholder : undefined,
    ref: register,
    required: lastNameRequired,
    type: "text",
    visible: lastNameVisible
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-fullName-required",
    "aria-invalid": (errors === null || errors === void 0 ? void 0 : errors.fullName) ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$fullName = errors.fullName) === null || _errors$fullName === void 0 ? void 0 : _errors$fullName.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/full-name",
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$fullName = formCopy.fullName) === null || _formCopy$fullName === void 0 ? void 0 : _formCopy$fullName.label,
    name: "fullName",
    placeholder: showPlaceholders ? formCopy.fullName.placeholder : undefined,
    ref: register,
    required: fullNameRequired,
    type: "text",
    visible: fullNameVisible
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-dob-required",
    "aria-invalid": (errors === null || errors === void 0 ? void 0 : errors.dob) ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$dob = errors.dob) === null || _errors$dob === void 0 ? void 0 : _errors$dob.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/dob",
    initialValue: birthdayInitialValue,
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$dob = formCopy.dob) === null || _formCopy$dob === void 0 ? void 0 : _formCopy$dob.label,
    name: "birthday input does not have a name prop",
    placeholder: formCopy.dob.placeholder,
    ref: register,
    required: birthdayRequired,
    type: "birthday",
    visible: birthdayVisible
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-country-required",
    "aria-invalid": (errors === null || errors === void 0 ? void 0 : errors.country) ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$country = errors.country) === null || _errors$country === void 0 ? void 0 : _errors$country.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/country",
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$country = formCopy.country) === null || _formCopy$country === void 0 ? void 0 : _formCopy$country.label,
    name: "country",
    options: formCopy.country.options,
    ref: register,
    required: countryRequired,
    type: "select",
    visible: countryVisible
  }), /*#__PURE__*/_react.default.createElement(_Input.default, {
    "aria-describedby": "error-gender-required",
    "aria-invalid": (errors === null || errors === void 0 ? void 0 : errors.gender) ? 'true' : 'false',
    errorMessage: errors === null || errors === void 0 ? void 0 : (_errors$gender = errors.gender) === null || _errors$gender === void 0 ? void 0 : _errors$gender.message,
    id: "com.fitnesskeeper.runkeeper.pro:id/gender",
    label: formCopy === null || formCopy === void 0 ? void 0 : (_formCopy$gender = formCopy.gender) === null || _formCopy$gender === void 0 ? void 0 : _formCopy$gender.label,
    name: "gender",
    options: formCopy.gender.options,
    ref: register,
    required: genderRequired,
    type: "select",
    visible: genderVisible
  }), /*#__PURE__*/_react.default.createElement(_NewsletterCheckbox.default, {
    ref: register,
    visible: newsletterOptVisible
  }, formCopy.newsletterOpt));
};

UserInfoInputs.defaultProps = {
  birthdayInitialValue: '',
  birthdayRequired: false,
  birthdayVisible: false,
  countryRequired: false,
  countryVisible: false,
  emailRequired: false,
  emailVisible: false,
  errors: {},
  firstNameRequired: false,
  firstNameVisible: false,
  formCopy: {
    country: {
      label: '',
      options: {
        a: 'a'
      }
    },
    dob: {
      label: '',
      placeholder: ''
    },
    email: {
      label: '',
      placeholder: ''
    },
    firstName: {
      label: '',
      placeholder: ''
    },
    fullName: {
      label: '',
      placeholder: ''
    },
    gender: {
      label: '',
      options: {
        a: 'a'
      }
    },
    lastName: {
      label: '',
      placeholder: ''
    },
    newsletterOpt: '',
    password: {
      label: '',
      placeholder: ''
    }
  },
  fullNameRequired: false,
  fullNameVisible: false,
  genderRequired: false,
  genderVisible: false,
  lastNameRequired: false,
  lastNameVisible: false,
  newsletterOptVisible: false,
  passwordRequired: false,
  passwordVisible: false,
  prepopulatedEmail: null,
  showPlaceholders: false
};
var _default = UserInfoInputs;
exports.default = _default;